var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-core__header__right",
      attrs: { "data-onboarding": "welcome" },
    },
    [
      _c("div", { staticClass: "emd-drawer _right" }, [
        _c(
          "div",
          {
            staticClass: "emd-drawer__trigger",
            class: { _open: _vm.isOpenned },
            on: { click: _vm.toggleMobileMenu },
          },
          [_vm._m(0)]
        ),
        _c(
          "div",
          {
            staticClass: "emd-drawer__content",
            class: { _open: _vm.isOpenned },
          },
          [
            _c("emd-application"),
            _c(
              "span",
              [
                _c(
                  "emd-tippy",
                  {
                    staticClass: "emd-action-button _has-tooltip",
                    attrs: {
                      href: _vm.urlCompany,
                      id: "company",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      tag: "a",
                      type: "action-button",
                      content: _vm.$t("company"),
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "emd-action-button__icon uil uil-building",
                    }),
                  ]
                ),
              ],
              1
            ),
            _c("emd-user-menu"),
            _vm.isEmployee
              ? _c(
                  "span",
                  [
                    _c(
                      "emd-tippy",
                      {
                        class: [
                          "emd-action-button _type_outline _has-tooltip",
                          _vm.backofficeIconClass,
                        ],
                        attrs: {
                          href: _vm.urlBackoffice,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          id: "backoffice",
                          tag: "a",
                          type: "action-button",
                          content: _vm.$t("backoffice"),
                        },
                      },
                      [_c("span", [_c("emd-pagarme-icon")], 1)]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "emd-action-button eu-ml_1" }, [
      _c("i", { staticClass: "emd-action-button__icon uil uil-ellipsis-v" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }